/**
 * Container for an Text View component.
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import { ScreenSection } from '../../api/types'

export interface OwnProps {
	section: ScreenSection
	isInsideModal: boolean
}

export interface Props extends OwnProps {}

export interface Actions {}

const mapStateToProps = (_state: RootStoreState, ownProps: OwnProps): Props => ({
	...ownProps,
})

const mapDispatchToProps = (_dispatch: Dispatch<AnyAction>): Actions => ({})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
